// Zentrales Tracking: stabile Ereignisnamen, Consent Mode v2, keinerlei
// personenbezogene Formularinhalte in Events / dataLayer / URLs.

export const CONSENT_COOKIE = "mabuhay_consent";

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_COOKIE);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { necessary: true, statistics: !!parsed.statistics, marketing: !!parsed.marketing, ts: parsed.ts };
  } catch {
    return null;
  }
}

export function saveConsentLocal(consent) {
  localStorage.setItem(CONSENT_COOKIE, JSON.stringify({ ...consent, ts: new Date().toISOString() }));
}

export function clearOptionalStorage() {
  // Widerruf: optionale eigene Speicherwerte entfernen (soweit technisch moeglich).
  try {
    localStorage.removeItem("mabuhay_attribution");
  } catch { /* ignore */ }
  ["_ga", "_gid", "_fbp", "_fbc"].forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}`;
    document.cookie = `${name}=; Max-Age=0; path=/`;
  });
}

export function pushConsentMode(consent) {
  if (typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    analytics_storage: consent.statistics ? "granted" : "denied",
    ad_storage: consent.marketing ? "granted" : "denied",
    ad_user_data: consent.marketing ? "granted" : "denied",
    ad_personalization: consent.marketing ? "granted" : "denied",
  });
}

export function trackEvent(name, params = {}) {
  const consent = getConsent() || { statistics: false, marketing: false };
  // Kontakt-Events sind ersteinwilligungsfrei in den dataLayer spiegelbar? Nein:
  // ohne Einwilligung keine optionalen Tracking-Requests. Intern nicht speichern.
  if (!consent.statistics && !consent.marketing) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
}

export function captureAttribution() {
  // Werbeparameter nur mit Einwilligung (Marketing) bereinigt speichern.
  const consent = getConsent();
  if (!consent || !consent.marketing) return null;
  const url = new URL(window.location.href);
  const p = url.searchParams;
  const attribution = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "gbraid", "wbraid", "fbclid"].forEach((k) => {
    const v = p.get(k);
    if (v) attribution[k] = v.slice(0, 200);
  });
  attribution.landing_path = url.pathname; // bereinigt, ohne Query
  const ref = document.referrer;
  if (ref) {
    try {
      attribution.referrer_host = new URL(ref).hostname; // nur Host, keine URL-Details
    } catch { /* ignore */ }
  }
  try {
    localStorage.setItem("mabuhay_attribution", JSON.stringify(attribution));
  } catch { /* ignore */ }
  return attribution;
}

export function getStoredAttribution() {
  const consent = getConsent();
  if (!consent || !consent.marketing) return null;
  try {
    return JSON.parse(localStorage.getItem("mabuhay_attribution") || "null");
  } catch {
    return null;
  }
}

// ------------------------------------------------------------------
// Google Ads Conversion-Messung (AW-18552203199)
// Labels kommen aus der Frontend-Konfiguration (REACT_APP_GOOGLE_ADS_SEND_TO_*).
// Ohne Marketing-Einwilligung oder ohne konfiguriertes Label wird NICHTS
// gesendet (keine fingierten Requests). Klick-Conversions sind sekundaere
// Aktionen: ein Klick beweist weder Gespraech noch Nachricht noch Anfrage.

const AW_ID = "AW-18552203199";

export function normalizePhoneE164(phone) {
  if (!phone) return null;
  let p = phone.replace(/[^\d+]/g, "");
  if (p.startsWith("00")) p = "+" + p.slice(2);
  if (p.startsWith("0")) p = "+49" + p.slice(1);
  if (!p.startsWith("+")) return null;
  return p.length >= 8 ? p : null;
}

export function adsConversion(label, userData) {
  const consent = getConsent();
  if (!consent || !consent.marketing) return; // nur mit Marketing-Einwilligung
  if (!label || typeof window.gtag !== "function") return;
  if (userData && (userData.email || userData.phone_number)) {
    window.gtag("set", "user_data", userData); // Google hasht die Werte automatisch
  }
  window.gtag("event", "conversion", { send_to: label });
}

export const ADS_LABELS = {
  form: process.env.REACT_APP_GOOGLE_ADS_SEND_TO_FORM || null,
  whatsapp: process.env.REACT_APP_GOOGLE_ADS_SEND_TO_WHATSAPP || null,
  phone: process.env.REACT_APP_GOOGLE_ADS_SEND_TO_PHONE || null,
};

// Ein Conversion-Request pro Absenden/Klick – Dedupe ueber Aufrufstelle
// (form: client_submit_id; Klicks: Event Delegation feuert pro Klick genau 1x).
export function trackSpaPageView(pathname) {
  const consent = getConsent();
  if (!consent || (!consent.statistics && !consent.marketing)) return;
  if (typeof window.gtag !== "function") return;
  window.gtag("config", AW_ID, { page_path: pathname });
}
